angular
  .module('contrast.factory.password', [])
  .factory('PasswordFactory', function ($http, UserService) {
    return {
      getRestrictions: function () {
        //does not require orgUuid
        return $http.get('/Contrast/api/ng/passwordpolicy/restrictions')
      },

      getPolicy: function () {
        return $http.get(UserService.buildAPIUrl('/passwordpolicy'))
      },
      updatePolicy: function (data) {
        return $http.put(UserService.buildAPIUrl('/passwordpolicy'), data)
      }
    }
  })
